module.exports = __webpack_public_path__ + "img/07.0154d070.jpg";